/* jshint ignore:start */
/*
 * jQuery throttle / debounce - v1.1 - 3/7/2010
 * http://benalman.com/projects/jquery-throttle-debounce-plugin/
 *
 * Copyright (c) 2010 "Cowboy" Ben Alman
 * Dual licensed under the MIT and GPL licenses.
 * http://benalman.com/about/license/
 */
(function(b,c){var $=b.jQuery||b.Cowboy||(b.Cowboy={}),a;$.throttle=a=function(e,f,j,i){var h,d=0;if(typeof f!=="boolean"){i=j;j=f;f=c}function g(){var o=this,m=+new Date()-d,n=arguments;function l(){d=+new Date();j.apply(o,n)}function k(){h=c}if(i&&!h){l()}h&&clearTimeout(h);if(i===c&&m>e){l()}else{if(f!==true){h=setTimeout(i?k:l,i===c?e-m:e)}}}if($.guid){g.guid=j.guid=j.guid||$.guid++}return g};$.debounce=function(d,e,f){return f===c?a(d,e,false):a(d,f,e!==false)}})(this);
/* jshint ignore:end */


(function( $ ) {

    $.fn.makeGreedy = function() {

        return this.each(function() {
        // Do something to each element here.

          var $el         = $(this);

          var $btn        = $el.find('button');
          var $vlinks     = $el.find('.links');
          var $hlinks     = $el.find('.hidden-links');

          var numOfItems  = 0;
          var totalSpace  = 0;
          var closingTime = 1000;
          var breakWidths = [];
          var timer;
          // Get initial state
          //console.log($vlinks);
          $vlinks.children().outerWidth(function(i, w) {
            totalSpace += w;
            numOfItems += 1;
            breakWidths.push(totalSpace);
            //console.log($(this));
          });
          // console.log(breakWidths);
          // console.log($vlinks.width());

          function check() {
            // console.log($el);
            // console.log(numOfItems);
            var availableSpace, numOfVisibleItems, requiredSpace;
            // Get instant state
            availableSpace = $vlinks.width() - 40;
            numOfVisibleItems = $vlinks.children().length;
            requiredSpace = breakWidths[numOfVisibleItems - 1];
           // console.log(requiredSpace);
            // There is not enought space
            if (requiredSpace > availableSpace) {
              $vlinks.children().last().prependTo($hlinks);
              numOfVisibleItems -= 1;
              check();
              // There is more than enough space
            } else if (availableSpace > breakWidths[numOfVisibleItems]) {
              $hlinks.children().first().appendTo($vlinks);
              numOfVisibleItems += 1;
              check();
            }
            // Update the button accordingly
            $btn.attr("count", numOfItems - numOfVisibleItems);
            if (numOfVisibleItems === numOfItems) {
              $btn.addClass('hidden');
            } else {
              $btn.removeClass('hidden');
            }
          }

          // Window listeners
          var debounced = jQuery.debounce( 650, false, check );
          $(window).on('resize orientationchange',debounced);

          $btn.on('click', function() {
            $hlinks.toggleClass('hidden');
            clearTimeout(timer);
          });

          $hlinks.on('mouseleave', function() {
            // Mouse has left, start the timer
            timer = setTimeout(function() {
              $hlinks.addClass('hidden');
            }, closingTime);
          }).on('mouseenter', function() {
            // Mouse is back, cancel the timer
            clearTimeout(timer);
          });

          check();


        });

    };

}( jQuery ));
